"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    activateStbDevice: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.ACTIVATE_STB_DEVICE,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.activateSkyDecoder;
        },
    })), api_1.createApiInitialState(null)),
    activateStbDeviceAsync: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.ACTIVATE_STB_DEVICE_ASYNC,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.activateSkyDecoderAsync;
        },
    })), api_1.createApiInitialState(null)),
    deviceActivationInitiated: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_INITIATE_DEVICE_ACTIVATION] = function (_, action) { return action.payload.value; },
        _a), null),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map